import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4151fdb8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "gameBoard" }
const _hoisted_2 = { class: "align-self-center" }


import GridTileView from "@/views/game/GridTileView.vue";

type Props = {
  gameState: string[][];
  validMoves: boolean[][];
  rows: number[];
  columns: number[];
};


export default /*#__PURE__*/_defineComponent({
  __name: 'GridView',
  props: {
    gameState: null,
    validMoves: null,
    rows: null,
    columns: null
  },
  emits: ["tilePressed"],
  setup(__props: any, { emit }) {




const specialSquares = [
  [5, 5],
  [0, 10],
  [10, 0],
  [0, 0],
  [10, 10],
];

function tilePressedACB(loc: string) {
  emit("tilePressed", loc);
}

return (_ctx: any,_cache: any) => {
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_v_col, { cols: "1" }, {
          default: _withCtx(() => [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(11, (i) => {
              return _createVNode(_component_v_row, { key: i }, {
                default: _withCtx(() => [
                  _createElementVNode("p", _hoisted_2, _toDisplayString(10 - i + 2), 1)
                ]),
                _: 2
              }, 1024)
            }), 64))
          ]),
          _: 1
        }),
        _createVNode(_component_v_col, null, {
          default: _withCtx(() => [
            _createVNode(_component_v_card, null, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.rows, (row) => {
                  return (_openBlock(), _createBlock(_component_v_row, { key: row }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.columns, (col) => {
                        return (_openBlock(), _createBlock(GridTileView, {
                          class: _normalizeClass(
                'square ' +
                ((row + col) % 2 === 1
                  ? 'light'
                  : specialSquares.some(
                      (loc) => loc[0] === row && loc[1] === col
                    )
                  ? 'darker'
                  : 'dark')
              ),
                          key: col,
                          location: [row, col],
                          "tile-value": __props.gameState[row][col],
                          "is-valid-move": __props.validMoves[row][col],
                          onTilePressed: tilePressedACB
                        }, null, 8, ["class", "location", "tile-value", "is-valid-move"]))
                      }), 128))
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList('abcdefghijk', (l) => {
                  return _createVNode(_component_v_col, {
                    key: l,
                    class: "pa-0"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("p", null, _toDisplayString(l), 1)
                    ]),
                    _: 2
                  }, 1024)
                }), 64))
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})